export const calculatePrecision = (step) => {
  if (step < 1) {
    const stepString = step.toString();
    const decimalIndex = stepString.indexOf(".");
    return decimalIndex !== -1 ? stepString.length - decimalIndex - 1 : 0;
  }
  return 0;
};

